export default __webpack_public_path__ + "static/media/alert-red.b81afa8f.svg";